// Zone.js configuration flags
// These flags must be set BEFORE zone.js is imported

// Disable patch for onProperty such as onclick - prevents UIkit conflicts
(window as any).__Zone_disable_on_property = true;

// Disable patch requestAnimationFrame - prevents potential infinite loops with UIkit
(window as any).__Zone_disable_requestAnimationFrame = true;

// Disable specified events that can cause issues with UIkit
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove', 'resize'];
